import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

import {
  addProductAPI,
  addProductStrainAPI,
  assignInventoryAPI,
  createProductBatchAPI,
  createProductTraitAPI,
  deleteProductAPI,
  deleteProductBatchAPI,
  deleteProductStrainAPI,
  deleteProductTraitAPI,
  fetchHoldQuantityAPI,
  fetchProductBatchsAPI,
  fetchProductDetailsAPI,
  fetchProductInstructionsAPI,
  fetchProductInventoriesAPI,
  fetchProductStrainsAPI,
  fetchProductTerpenoidAPI,
  fetchProductTraitAPI,
  fetchProductTraitsAPI,
  fetchProductsAPI,
  getDeliverySlotsApi,
  getProductCarouselsAPI,
  getProductTraitDetailAPI,
  getSubTraitsForMainAPI,
  productActivityLogsAPI,
  productFiltersAPI,
  updateProductAPI,
  updateProductBatchAPI,
  updateProductTraitAPI,
} from "../apis/products";
import { axiosHyperwolfClient } from "axiosClient";
const initialState = {
  products: [],
  loading: false,
  error: null,
  singleProduct: null,
  productTraits: [],
  loadingProductTraits: false,
  productTerpenoids: {},
};

// Define your asynchronous thunk
export const updateProductSeo = createAsyncThunk(
  "product/updateProductSeo",
  async ({ productId, data }, { rejectWithValue }) => {

    try {
      const res = await axiosHyperwolfClient.put(`/api/v1/product/seo/${productId}`, data);

      return res.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Failed to update product SEO");
    }
  }
);

export const fetchProducts = createAsyncThunk(
  "product/fetchProducts",
  async ({ filters, payload }, { rejectWithValue }) => {
    try {
      const res = await fetchProductsAPI(filters, payload);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchSingleProduct = createAsyncThunk(
  "product/fetchSingleProduct",
  async (productId, { rejectWithValue }) => {
    try {
      const res = await fetchProductDetailsAPI(productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchProductBatches = createAsyncThunk(
  "product/fetchProductBatches",
  async ({ filters, productId }, { rejectWithValue }) => {
    try {
      const res = await fetchProductBatchsAPI(filters, productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateProductBatch = createAsyncThunk(
  "product/updateProductBatch",
  async ({ data, productBatchId }, { rejectWithValue }) => {
    try {
      const res = await updateProductBatchAPI(data, productBatchId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteProductBatch = createAsyncThunk(
  "product/deleteProductBatch",
  async (data, { rejectWithValue }) => {
    try {
      const res = await deleteProductBatchAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchProductInventories = createAsyncThunk(
  "product/fetchProductInventories",
  async ({ filters, productId }, { rejectWithValue }) => {
    try {
      const res = await fetchProductInventoriesAPI(filters, productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addProduct = createAsyncThunk(
  "product/addProduct",
  async (data, { rejectWithValue }) => {
    try {
      const res = await addProductAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "product/updateProduct",
  async ({ data, productId }, { rejectWithValue }) => {
    try {
      const res = await updateProductAPI(data, productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const assignInventory = createAsyncThunk(
  "product/assignInventory",
  async (data, { rejectWithValue }) => {
    try {
      const res = await assignInventoryAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const createProductBatch = createAsyncThunk(
  "product/createProductBatch",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createProductBatchAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "product/deleteProduct",
  async (productId, { rejectWithValue }) => {
    try {
      const res = await deleteProductAPI(productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchProductTerpenoids = createAsyncThunk(
  "product/fetchProductTerpenoids",
  async ({ filters, productId }, { rejectWithValue }) => {
    try {
      const res = await fetchProductTerpenoidAPI(filters, productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
export const fetchFilterProducts = createAsyncThunk(
  "product/fetchFilterProducts",
  async ({ filters, productId }, { rejectWithValue }) => {
    try {
      const res = await productFiltersAPI(filters, productId);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchProductActivityLogs = createAsyncThunk(
  "product/fetchProductActivityLogs",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await productActivityLogsAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchProductInstructions = createAsyncThunk(
  "product/fetchProductInstructions",
  async ({ categoryName }, { rejectWithValue }) => {
    try {
      const res = await fetchProductInstructionsAPI(categoryName);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const fetchHoldQuantity = createAsyncThunk(
  "product/fetchHoldQuantity",
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetchHoldQuantityAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const createProductTrait = createAsyncThunk(
  "product/addProductTrait",
  async (data, { rejectWithValue }) => {
    try {
      const res = await createProductTraitAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const updateProductTrait = createAsyncThunk(
  "product/updateProductTrait",
  async (data, { rejectWithValue }) => {
    try {
      const res = await updateProductTraitAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchProductTraits = createAsyncThunk(
  "product/productTraits",
  async ({ id, filters }, { rejectWithValue }) => {
    try {
      const res = await fetchProductTraitsAPI(id, filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteProductTrait = createAsyncThunk(
  "product/deleteTraitId",
  async ({ productId, productTraitId }, { rejectWithValue }) => {
    try {
      const res = await deleteProductTraitAPI(productId, productTraitId);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addProductStrains = createAsyncThunk(
  "product/addStrain",
  async (data, { rejectWithValue }) => {
    try {
      const res = await addProductStrainAPI(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchProductStrains = createAsyncThunk(
  "product/productStrains",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await fetchProductStrainsAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteProductStrain = createAsyncThunk(
  "product/deleteProductStrain",
  async ({ productId, subStrainSlug }, { rejectWithValue }) => {
    try {
      const res = await deleteProductStrainAPI(productId, subStrainSlug);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const getProductTraitDetail = createAsyncThunk(
  "product/productTraitDetails",
  async ({ productId, traitId }, { rejectWithValue }) => {
    try {
      const res = await getProductTraitDetailAPI(productId, traitId);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response);
    }
  }
);

export const getSubTraitForMain = createAsyncThunk(
  "products/getSubTraits",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getSubTraitsForMainAPI(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);


export const getDeliverySlots = createAsyncThunk(
  "products/getDeliverySlots",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getDeliverySlotsApi(filters);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchProductCarousels = createAsyncThunk(
  "products/fetchProductCarousels",
  async (filters, { rejectWithValue }) => {
    try {
      const res = await getProductCarouselsAPI(filters);
      return res?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const deleteProductCarousel = createAsyncThunk(
  'common/deleteProductCarousel',
  async (id, { rejectWithValue }) => {
    try {
      const res = await axiosHyperwolfClient.delete(`/api/v1/product/carousel/${id}`);
      return res?.data
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)

export const updateCarouselsStatusApi = createAsyncThunk(
  'common/updateCarouselsStatusApi',
  async ({id,data}, { rejectWithValue }) => {
    try {
      const res = await axiosHyperwolfClient.patch(`/api/v1/product/carousel/update/status/${id}`,data);
      return res?.data
    } catch (error) {

      return rejectWithValue(error.response?.data)
    }
  }
)
// Create a slice
const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    // Define extra reducers here
    clearProducts: (state) => {
      state.products = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateProductSeo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateProductSeo.fulfilled, (state, action) => {
        state.loading = false;
        state.seo = action.payload;
      })
      .addCase(updateProductSeo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchProducts.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.singleProduct = {};
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchSingleProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSingleProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.singleProduct = action.payload;
      })
      .addCase(fetchSingleProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(deleteProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.loading = false;
        // Handle successful deletion if needed
      })
      .addCase(deleteProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Handle the error: store the error payload in state
      });

    builder
      // Handling pending action for fetching inventories
      .addCase(fetchProductInventories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // Handling fulfilled action after successfully fetching inventories
      .addCase(fetchProductInventories.fulfilled, (state, action) => {
        state.loading = false;
        state.inventories = action.payload; // Assuming the payload contains the inventories
      })
      // Handling rejected action if fetching inventories encounters an error
      .addCase(fetchProductInventories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Assuming the payload contains the error details
      });

    builder
      .addCase(updateProduct.pending, (state) => {
        state.isUpdating = true;
        state.error = null;
        state.updatedProduct = null;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.isUpdating = false;
        state.updatedProduct = action.payload;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.isUpdating = false;
        state.error = action.payload;
      });

    builder
      .addCase(addProduct.pending, (state) => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.isUpdating = false;
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.isUpdating = false;
      });

    builder
      .addCase(deleteProductBatch.pending, (state) => {
        state.isDeleting = true;
        state.error = null;
        state.deletedBatch = null;
      })
      .addCase(deleteProductBatch.fulfilled, (state, action) => {
        state.isDeleting = false;
        state.deletedBatch = action.payload;
      })
      .addCase(deleteProductBatch.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchProductBatches.pending, (state) => {
        state.isFetching = true;
        state.error = null;
        state.productBatches = null;
      })
      .addCase(fetchProductBatches.fulfilled, (state, action) => {
        state.isFetching = false;
        state.productBatches = action.payload;
      })
      .addCase(fetchProductBatches.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      });

    builder
      .addCase(fetchProductTerpenoids.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchProductTerpenoids.fulfilled, (state, action) => {
        state.isFetching = false;
        state.productTerpenoids = action.payload; // Assuming your API response is the data you want to store
      })
      .addCase(fetchProductTerpenoids.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload; // The rejection value from the async thunk
      });

    builder
      .addCase(fetchFilterProducts.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchFilterProducts.fulfilled, (state, action) => {
        state.isFetching = false;
      })
      .addCase(fetchFilterProducts.rejected, (state, action) => {
        state.isFetching = false;
      });
    builder
      .addCase(createProductBatch.pending, (state) => {
        state.isUpdating = true;
      })
      .addCase(createProductBatch.fulfilled, (state, action) => {
        state.isUpdating = false;
      })
      .addCase(createProductBatch.rejected, (state, action) => {
        state.isUpdating = false;
      });

    builder
      .addCase(updateProductBatch.pending, (state) => {
        state.isUpdating = true;
      })
      .addCase(updateProductBatch.fulfilled, (state, action) => {
        state.isUpdating = false;
      })
      .addCase(updateProductBatch.rejected, (state, action) => {
        state.isUpdating = false;
      });

    builder
      .addCase(fetchProductActivityLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProductActivityLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.activityLogs = action.payload;
      })
      .addCase(fetchProductActivityLogs.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(fetchHoldQuantity.pending, (state) => {
        state.isloading = true;
      })
      .addCase(fetchHoldQuantity.fulfilled, (state, action) => {
        state.isloading = false;
        state.getHoldQuantity = action.payload;
      })
      .addCase(fetchHoldQuantity.rejected, (state, action) => {
        state.isloading = false;
      });

    // Add this to your extraReducers
    builder
      .addCase(fetchProductTraits.pending, (state) => {
        state.loadingProductTraits = true;
        state.error = null;
      })
      .addCase(fetchProductTraits.fulfilled, (state, action) => {
        state.loadingProductTraits = false;
        state.productTraits = action.payload; // Store traits separately
      })
      .addCase(fetchProductTraits.rejected, (state, action) => {
        state.loadingProductTraits = false;
        state.error = action.payload;
      });

    builder
      .addCase(createProductTrait.pending, (state) => {
        state.loadingProductTraits = true;
        state.error = null;
      })
      .addCase(createProductTrait.fulfilled, (state, action) => {
        state.loadingProductTraits = false;
        state.productTraits = action.payload;
      })
      .addCase(createProductTrait.rejected, (state, action) => {
        state.loadingProductTraits = false;
        state.error = action.payload || "Failed to fetch product details";
      });

    builder
      .addCase(updateProductTrait.pending, (state) => {
        state.loadingProductTraits = true;
        state.error = null;
      })
      .addCase(updateProductTrait.fulfilled, (state, action) => {
        state.loadingProductTraits = false;
        state.productTraits = action.payload; // Store the product details
      })
      .addCase(updateProductTrait.rejected, (state, action) => {
        state.loadingProductTraits = false;
        state.error = action.payload || "Failed to fetch product details";
      });

    builder
      .addCase(deleteProductTrait.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteProductTrait.fulfilled, (state, action) => {
        state.loading = false;
        // Handle successful deletion if needed
      })
      .addCase(deleteProductTrait.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Handle the error: store the error payload in state
      });

    builder
      .addCase(addProductStrains.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addProductStrains.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload; // Store the product details
      })
      .addCase(addProductStrains.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(getProductTraitDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductTraitDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.productTraits = action.payload;
      })
      .addCase(getProductTraitDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });


    builder
      .addCase(getDeliverySlots.pending, (state) => {
        state.fetchingSlots = true;
        state.error = null;
      })
      .addCase(getDeliverySlots.fulfilled, (state, action) => {
        state.fetchingSlots = false;
        state.deliverySlots = action.payload?.data;
      })
      .addCase(getDeliverySlots.rejected, (state, action) => {
        state.fetchingSlots = false;
        state.error = action.payload;
      });
    builder
      .addCase(fetchProductCarousels.pending, (state) => {
        state.fetchProductCarouselsLoading = true;
        state.error = null;
      })
      .addCase(fetchProductCarousels.fulfilled, (state, action) => {
        state.fetchProductCarouselsLoading = false;
        state.productCarousels = action.payload;
      })
      .addCase(fetchProductCarousels.rejected, (state, action) => {
        state.fetchProductCarouselsLoading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearProducts } = productsSlice.actions;
export default productsSlice.reducer;
